import { ActionType, AppActionTypes } from '../types';
import { ResetPasswordRequestValues, ResetPasswordValues, SignInValues, SignUpValues } from '../../interfaces';
import { IUser } from '@relab/alstom-ptw-shared';

export function signInAction(params: SignInValues): AppActionTypes {
  return {
    type: ActionType.SIGN_IN,
    payload: {
      request: {
        url: '/signin',
        method: 'post',
        data: params,
      },
    },
  };
}

export function signOutAction(): AppActionTypes {
  return {
    type: ActionType.SIGN_OUT,
  };
}

export function signUpAction(params: SignUpValues): AppActionTypes {
  return {
    type: ActionType.SIGN_UP,
    payload: {
      request: {
        url: '/signup',
        method: 'post',
        data: {
          userLevel: 50,
          ...params,
        },
      },
    },
  };
}

export function resetPasswordRequestAction(params: ResetPasswordRequestValues): AppActionTypes {
  return {
    type: ActionType.RESET_PASSWORD_REQUEST,
    payload: {
      request: {
        url: '/passwordreset',
        method: 'post',
        data: params,
      },
    },
  };
}

export function resetPasswordAction(params: ResetPasswordValues): AppActionTypes {
  const { token, email, password } = params;
  return {
    type: ActionType.RESET_PASSWORD,
    payload: {
      request: {
        url: `/passwordreset/${token}`,
        method: 'post',
        data: {
          email,
          password,
        },
      },
    },
  };
}

export function checkLoginAction(): AppActionTypes {
  return {
    type: ActionType.CHECK_LOGIN,
    payload: {
      request: {
        url: '/checklogin',
        method: 'get',
      },
    },
  };
}

export function usersAction(): AppActionTypes {
  return {
    type: ActionType.USERS,
    payload: {
      request: {
        url: '/users',
        method: 'get',
      },
    },
  };
}

export function userEditAction(params: Partial<IUser>): AppActionTypes {
  return {
    type: ActionType.USER_EDIT,
    payload: {
      request: {
        url: `/edituser`,
        method: 'post',
        data: {
          ...params,
        },
      },
      user: {
        ...params,
      },
    },
  };
}
export function userDeleteAction(userId: string): AppActionTypes {
  return {
    type: ActionType.USER_DELETE,
    payload: {
      request: {
        url: `/user/${userId}`,
        method: 'delete',
      },
      user: {
        _id: userId,
      },
    },
  };
}
